import React from 'react';

import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { useField } from 'app-components/flux/categories/categoryFormHooks';

import TaxFormPersonal from './TaxFormPersonal';
import TaxLineItemPersonal from './TaxLineItemPersonal';

import TaxRelated from './TaxRelated';
import useStyles from './styles';

const TaxInfoQBPPersonal = () => {
  const { classes } = useStyles();
  const { value: taxRelated } = useField('taxRelated');

  return (
    <Stack mt={2} flex='1'>
      <Card className={classes.taxGroupCard}>
        <Stack direction='column' spacing={3} flex='1'>
          <Stack
            direction='row'
            sx={{
              mt: 2,
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant='bodyMedium'>Tax Related</Typography>
            <TaxRelated />
          </Stack>
          {taxRelated && (
            <>
              <TaxFormPersonal />
              <TaxLineItemPersonal />
            </>
          )}
        </Stack>
      </Card>
    </Stack>
  );
};

export default TaxInfoQBPPersonal;
